import { FormGroup, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import InputList from '../../../InputList';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    ...theme.palette.alternateText,
    fontWeight: 'bold',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,

    '& > .MuiFormControlLabel-label': {
      fontWeight: 'bold',
    },
  },
  item: {
    color: theme.palette.baseColors.skyBlue.c75,
    '&.Mui-checked': {
      color: theme.palette.baseColors.skyBlue.c75,
    },
  },
  minMaxContainer: {
    ...theme.palette.altScrollbarBlue,
    overflow: 'auto',
    padding: '5px 15px 0',
    flexWrap: 'nowrap',
  },
}));

const getValue = (value) => {
  // check if value is a number or a string that can be converted to a number
  if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
    return parseFloat(value);
  }
  return value || '';
};

const MinMaxFilter = ({ filter, handleSetState, loading }) => {
  const classes = useStyles();
  const [filterState, setFilterState] = useState({
    [filter.min.key]: getValue(filter.min.initialValue),
    [filter.max.key]: getValue(filter.max.initialValue),
  });

  useEffect(() => {
    if (!loading) {
      setFilterState({
        [filter.min.key]: getValue(filter.min.initialValue),
        [filter.max.key]: getValue(filter.max.initialValue),
      });
    }
  }, [loading]);

  const onSetDefaultValues = (item) => {
    const minValue = { [item.min?.key]: getValue(item.min?.default) };
    const maxValue = { [item.max?.key]: getValue(item.max?.default) };
    setFilterState({ ...filterState, ...minValue, ...maxValue });
    handleSetState({ ...minValue, ...maxValue });
  };
  const handleSetFilterState = (value, name) => {
    setFilterState({ ...filterState, [name]: value });
    handleSetState({ [name]: value });
  };

  return (
    <Box width={'100%'}>
      <Typography className={classes.label} variant="overline">
        Limits
      </Typography>
      <FormGroup>
        <div className={classes.minMaxContainer}>
          <InputList
            values={filterState}
            setInput={handleSetFilterState}
            items={[filter]}
            onSetDefaultValues={onSetDefaultValues}
          />
        </div>
      </FormGroup>
    </Box>
  );
};

export default MinMaxFilter;
